import { Column } from "../../../components/dataTable/dataTable";
import { ICity } from "../../../types";
import getIdNumber from "../../../utils/get-id-number";

interface GetColumnsProps {
  currentPage: number;
  rowsPerPage: number;
  data: ICity[];
}

export const getColumns = ({
  currentPage,
  rowsPerPage,
  data,
}: GetColumnsProps): Column<ICity>[] => [
  {
    key: "index",
    label: "No.",
    align: "center",
    render: (row: ICity) => {
      const position = data.indexOf(row);
      if (position === -1) return "-"; // fallback (should not happen)
      return position + 1 + currentPage * rowsPerPage;
    },
  },
  { key: "city", label: "City" },
  { key: "state", label: "State", align: "center" },
  { key: "country", label: "Country", align: "center" },
  { key: "actions", label: "Action", align: "center" },
];
